import { ref } from 'vue'

// State
export const contentId = ref(null)
export const isSaving = ref(false)
export const isPublishing = ref(false)
export const isSaved = ref(false)
export const isPublished = ref(false)
export const contentAnalytics = ref({
  views: 0,
  likes: 0,
  comments: 0,
  shares: 0,
})
